<template>
  <div class="header">
      <div class="single-top">
        <img class="single-icon" :src="types[0].imgSelected" />
        <p class="title">{{ types[0].title }}</p>
        <p class="trend_reason_desc">{{ruleMap[rankType] && ruleMap[rankType].content}}</p>
      </div>
      <div class="left">
        <!-- 榜单 -->
        <slot/>
      </div>
    </div>
</template>
<script>
export default {
  name: 'singleHeader',
  props: {
    header: {
      type: Object
    },
    ruleMap: {
      type: Object
    },
    rankType:{
      type: [String, Number]
    },
    types: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(#E8E8E7,#E8E8E7); 
  .single-top {
    padding-top: 88px;
    padding-bottom: 64px;
    width: 100vw;
    text-align: center;
    .single-icon {
      margin: 20px auto 0;
      display: block;
      width: 136px;
      height: 136px;
    }
    .title {
      margin-top: 4px;
      line-height: 72px;
      font-size: 60px;
      color: #8A5321;
      font-family: DiDiSans-Pro-Bold;
      font-weight: 700;
    }
    .trend_reason_desc {
      padding: 0 32px;
      margin-top: 6px;
      line-height: 30px;
      font-size: 22px;
      font-family: DiDiSans-Pro-Regular;
      font-weight: 400;
      color: #975425;
      opacity: 0.8;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .left {
    // position: absolute;
    // top: 176px;
    // top: 330px;
    // left: 0;
    display: flex;
    flex-direction: column;
    .left_title {
      max-width: 453px;
      // height: 222;
    }
    .left_desc {
      margin-left: 48px;
      width: 480px;
      opacity: 0.8;
      font-family: DiDiSans-Pro-Medium;
      font-size: 24px;
      color: #975425;
      letter-spacing: 0;
      line-height: 30px;
      font-weight: 400;
    }
  }
}
</style>